/**
 * Build /sell?fromRequest=… prefill URL (shared by demand strip + cards).
 * Params consumed by `sellFromRequestPrefill` on the sell page.
 */

import type { ItemRequest } from "@/lib/types";
import {
  preferenceAttrsAreEmpty,
  type PreferenceAttrs,
} from "./preferenceAttrs";
import { SELL_FROM_REQUEST_PARAM } from "./sellFromRequestPrefill";

export function buildSellFromRequestHref(request: ItemRequest): string {
  const params = new URLSearchParams({
    [SELL_FROM_REQUEST_PARAM.flag]: "true",
    [SELL_FROM_REQUEST_PARAM.requestId]: request.id,
    [SELL_FROM_REQUEST_PARAM.title]: request.title,
    [SELL_FROM_REQUEST_PARAM.description]: request.description ?? "",
    [SELL_FROM_REQUEST_PARAM.category]: request.category,
    [SELL_FROM_REQUEST_PARAM.location]: request.userLocation ?? "",
  });
  if (request.subcategory) {
    params.set(SELL_FROM_REQUEST_PARAM.subcategory, request.subcategory);
  }
  if (request.maxPrice != null) {
    params.set(SELL_FROM_REQUEST_PARAM.maxPrice, String(request.maxPrice));
  }
  const prefs = (request.preferenceAttrs ?? {}) as PreferenceAttrs;
  if (!preferenceAttrsAreEmpty(prefs)) {
    params.set(SELL_FROM_REQUEST_PARAM.prefs, JSON.stringify(prefs));
  }
  return `/sell?${params.toString()}`;
}
